const envUrls: EnvUrl = {
    dev: {
        flightReports:
            "https://wmtt-flight-reports-dev-fchbb0dghnaqfhgv.a02.azurefd.net/",
        termsofHire:
            "https://wmtt-hiring-charter-dev-fxg0g9bhf9ecdyhj.a02.azurefd.net/",
        wildfireAdmin: "https://admin.wildfireapps-dev.alberta.ca",
        finance: "https://contracts.wildfireapps-dev.alberta.ca",
        warehouseInventory: "https://contracts.wildfireapps-dev.alberta.ca",
        imis: "https://goa-cc-wmis-app-imis-dev.azurewebsites.net",
        fwt: "https://municipalreporting.wildfireapps-dev.alberta.ca",
        resourceOrders: "https://goa-cc-resource-orders-dev.azurewebsites.net",
        resourceOrdersAircraft:
            "https://goa-cc-wdp-resource-order-app-dev.azurewebsites.net",
        mobileFlightReport:
            "https://wmtt-pilot-aviation-reporting2-dev-cnfraefbd5dwejax.a02.azurefd.net/",
        timeTracking: "https://time-tracking.wildfireapps-dev.alberta.ca",
    },
    uat: {
        flightReports: "https://aviation.wildfireapps-uat.alberta.ca",
        termsofHire: "https://actermsofhire-uat.wildfireapps.int.gov.ab.ca/",
        wildfireAdmin: "https://admin.wildfireapps-uat.alberta.ca",
        finance: "https://contracts.wildfireapps-uat.alberta.ca",
        warehouseInventory: "https://contracts.wildfireapps-dev.alberta.ca",
        //imis: "https://imis.wildfireapps-uat.alberta.ca"
        imis: "https://goa-cc-wmis-app-imis-uat.azurewebsites.net",
        fwt: "https://municipalreporting.wildfireapps-uat.alberta.ca",
        resourceOrders: "https://goa-cc-resource-orders-uat.azurewebsites.net",
        resourceOrdersAircraft:
            "https://goa-cc-wdp-resource-order-app-uat.azurewebsites.net",
        mobileFlightReport:
            "https://goa-wdp-pilot-aviation-uat.azurewebsites.net",
        timeTracking: "https://time-tracking.wildfireapps-uat.alberta.ca",
    },
    prod: {
        flightReports: "https://aviation.wildfireapps.alberta.ca",
        termsofHire: "https://actermsofhire.wildfireapps.int.alberta.ca",
        wildfireAdmin: "https://admin.wildfireapps.alberta.ca",
        finance: "https://contracts.wildfireapps.alberta.ca",
        warehouseInventory: "https://contracts.wildfireapps-dev.alberta.ca",
        imis: "https://warehouse.wildfireapps.alberta.ca",
        fwt: "https://municipalreporting.wildfireapps.alberta.ca",
        resourceOrders: "https://resourceordering.wildfireapps.alberta.ca",
        resourceOrdersAircraft:
            "https://goa-cc-wdp-resource-order-app-prod.azurewebsites.net",
        mobileFlightReport: "https://flightreport.wildfireapps.alberta.ca",
        timeTracking: "https://time-tracking.wildfireapps.alberta.ca",
    },
};

interface EnvUrl {
    dev: UrlList;
    uat: UrlList;
    prod: UrlList;
}

export interface UrlList {
    flightReports: string;
    termsofHire: string;
    wildfireAdmin: string;
    finance: string;
    warehouseInventory: string;
    imis: string;
    fwt: string;
    resourceOrders: string;
    resourceOrdersAircraft: string;
    mobileFlightReport: string;
    timeTracking: string;
}

const appEnv = (process.env.REACT_APP_ENV as keyof EnvUrl) || "dev";

export const appList: AppConfig[] = [
    {
        url: envUrls[appEnv].flightReports,
        resource: "FlightReports",
        permission: ["p_Aviat_FlightRpt_R"],
        label: "Aviation",
        toolTipText: "Manage flight reports for aviation operations",
        enableLink: true,
        img: "helicopter.png",
    },
    {
        url: envUrls[appEnv].wildfireAdmin,
        resource: "wildfire-admin-api",
        permission: ["Adm_UserList_V"],
        label: "Application Administration",
        toolTipText: "Placeholder text",
        enableLink: true,
        img: "checklist.png",
    },
    {
        url: envUrls[appEnv].finance,
        resource: "finance",
        permission: ["Fin_Invoice_V"],
        label: "Finance",
        toolTipText: "Placeholder text",
        enableLink: true,
        img: "financialReport.png",
    },
    {
        url: envUrls[appEnv].imis,
        resource: "imis_client",
        permission: ["IMS_WO_V"],
        label: "Warehouse Management",
        toolTipText: "Placeholder text",
        enableLink: true,
        img: "warehouse.png",
    },
    {
        url: envUrls[appEnv].fwt,
        resource: "fwt-web-api",
        permission: ["FWT_FireRpt_V", "FWT_FireRpt_LocGov_V"],
        label: "Municipal Reporting",
        toolTipText: "Wildfire incident report",
        enableLink: true,
        img: "fwt.png",
    },
    {
        url: envUrls[appEnv].resourceOrders,
        resource: "resourceorders_client",
        permission: ["Ord_Watcher_V"], //in R_OrderWatcher group
        label: "Resource Orders",
        toolTipText: "Resource Orders",
        enableLink: true,
        img: "resourceOrders.png",
    },
    {
        url: envUrls[appEnv].resourceOrdersAircraft,
        resource: "resourceorders_client_v2",
        permission: ["ROs_OrderRequest_W"],
        label: "Resource Orders-Aircraft",
        toolTipText: "Resource Orders-Aircraft",
        enableLink: true,
        img: "resourceOrders.png",
    },
    {
        url: envUrls[appEnv].mobileFlightReport,
        resource: "FlightReports",
        permission: ["Plt_PilotReport_V"],
        label: "Mobile Flight Report",
        toolTipText:
            "Mobile Flight Report for Pilots to enter daily flight reports",
        enableLink: true,
        img: "documenttext.png",
    },
    {
        url: envUrls[appEnv].timeTracking,
        resource: "wildfire-time-tracking-api",
        permission: ["Eqp_Time_V"],
        label: "Fireline Equipment Time Tracking",
        toolTipText:
            "Fireline Equipment Time Tracking for logging equipment usage",
        enableLink: true,
        img: "timeTracking.png",
    },
    {
        url: envUrls[appEnv].termsofHire,
        resource: "Hiring-API",
        permission: ["Hir_CasChart_V"],
        label: "Terms Of Hire",
        toolTipText: "Manage Terms of hire for Vendors",
        enableLink: true,
        img: "termsOfHire.png",
    },
];

class AppConfig {
    url?: string;
    resource?: string;
    permission?: string[];
    label?: string;
    toolTipText?: string;
    enableLink?: boolean;
    img?: string;
}
